export default function (tags: any) {
  return Object.entries(tags).map(([key, value]) => `${key}:${value}`);
}
